import axios from 'axios';
import {API_URL} from '../constants/index.js';
import {useInterceptor} from './apiUtils';

useInterceptor(axios);

export function getFestivals(params) {
	return axios({
		method: 'get',
		url: `${API_URL}/festivals`,
		params: params
	});
}

export function showFestival(slug, options = {}) {
	return axios({
		method: 'get',
		url: `${API_URL}/festivals/${slug}`,
		skipGlobalError: options.skipGlobalError === true,
	});
}
